import React from 'react';
import { Button } from '../../Backoffice/';
import Close from '../../Icons/dist/components/Close';

var CloseButton = function CloseButton() {
  return React.createElement(
    Button,
    { height: 'medium', theme: 'close-transparent', onClick: function onClick(e) {
        return e.preventDefault();
      } },
    React.createElement(Close, { size: '6px' })
  );
};

CloseButton.displayName = 'Notification.CloseButton';

export default CloseButton;
//# sourceMappingURL=CloseButton.js.map



// WEBPACK FOOTER //
// ./~/wix-style-react/dist/es/src/Notification/CloseButton/CloseButton.js